import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeProps as _normalizeProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import DeliveryInfo from "./components/DeliveryInfo.vue";
import OfferPrice from "../components/OfferPrice.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SetCardApp',
    props: {
        set: { type: Object, required: true },
        delivery: { type: Object, required: true },
        deliveryEl: { type: Object, required: true },
    },
    setup: function (__props) {
        var props = __props;
        var available = !!props.set.offers.find(function (offer) { return offer.active; });
        var offer = props.set.offers[0];
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(OfferPrice, { offer: _unref(offer) }, null, 8 /* PROPS */, ["offer"]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (_openBlock(), _createBlock(_Teleport, { to: __props.deliveryEl }, [
                    available
                        ? (_openBlock(), _createBlock(DeliveryInfo, _normalizeProps(_mergeProps({ key: 0 }, __props.delivery)), null, 16 /* FULL_PROPS */))
                        : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, ["to"]))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
